// src/components/UserInfo.jsx
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  FaUser,
  FaCalendarCheck,
  FaLeaf,
  FaNotesMedical,
  FaFileInvoiceDollar,
  FaBed,
  FaListUl,
} from "react-icons/fa";

import "./UserInfo.css";
import PatientInfo from "./UserInfoTabs/PatientInfo";
import CasePaper from "./UserInfoTabs/CasePaper";
import BookAppointment from "./UserInfoTabs/BookAppointment";
import BillingInfo from "./UserInfoTabs/BillingInfo";
import IpdAll from "./UserInfoTabs/IPD/IpdAll";
import IpdList from "./UserInfoTabs/IPD/IpdList";
import PrakritiAssessmentTab from "./UserInfoTabs/PrakritiAssessmentTab";

const UserInfo = () => {
  const [active, setActive] = useState("info");
  const { id } = useParams(); // 👈 get the patient ID from URL

  useEffect(() => {
    // console.log("Viewing patient with ID:", id);
    // You can fetch patient data here using `id`
  }, [id]);

  const handleAdmissionUpdate = () => {
  setActive("ipd-list"); // or any tab key you want to switch to
};

  const tabs = [
    { key: "info", label: "Patient Info", icon: <FaUser /> },
    { key: "book", label: "Appointments", icon: <FaCalendarCheck /> },
    { key: "prakriti", label: "Prakriti Parikshan", icon: <FaLeaf /> },
    { key: "case", label: "Consultation History", icon: <FaNotesMedical /> },
    { key: "billing", label: "Billing Info", icon: <FaFileInvoiceDollar /> },
    { key: "ipd-all", label: "IPD", icon: <FaBed /> },
    { key: "ipd-list", label: "IPD List", icon: <FaListUl /> },
  ];

  return (
    <div className="container patient-shell">
      <div className="patient-nav" role="tablist" aria-label="Patient sections">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={active === tab.key}
            className={`patient-nav-tab ${active === tab.key ? "active" : ""}`}
            onClick={() => setActive(tab.key)}
          >
            <span className="patient-nav-icon" aria-hidden="true">{tab.icon}</span>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>
      <div className="content">
        {active === "info" && <PatientInfo patientId={id} />}
        {active === "book" && <BookAppointment patientId={id} />}
        {active === "prakriti" && <PrakritiAssessmentTab patientId={id} />}
        {active === "case" && <CasePaper patientId={id} />}
        {active === "billing" && <BillingInfo patientId={id} />}
        {active === "ipd-all" && <IpdAll patientId={id} onUpdateSuccess={handleAdmissionUpdate}/>}
        {active === "ipd-list" && <IpdList patientId={id} />}
      </div>
    </div>
  );
};

export default UserInfo;
